import { RestProvider } from 'e100-data-providers';
import { IConfig } from 'config';
import * as authStorageProvider from 'dataSources/authStorageProvider';
import getCustomHeaders from 'dataSources/utils/getCustomHeaders';

import Common from './common';
import Auth from './auth';
import Stations from './stations';
import { ReportsApi } from 'entities/reports';
import Cards from './cards';
import User from './user';
import Events from './events';
import Maps from './maps';
import FavoriteCatalogs from './favoriteCatalogs';
import FuelCards from './fuelCards';
import TollRoads from './tollRoads';
import SavedFilters from './savedFilters';

const getApiTypicode = (config: IConfig) => {
  const provider = new RestProvider(
    { ...config, getCustomHeaders },
    authStorageProvider,
  );
  const authProvider = config.authServiceName
    ? new RestProvider(
        { ...config, serviceName: config.authServiceName, getCustomHeaders },
        authStorageProvider,
      )
    : provider;

  return {
    getProvider: () => provider,
    common: new Common(provider),
    auth: new Auth(authProvider),
    stations: new Stations(provider),
    reports: new ReportsApi(provider),
    cards: new Cards(provider),
    user: new User(provider),
    events: new Events(provider),
    maps: new Maps(provider),
    favoriteCatalogs: new FavoriteCatalogs(provider),
    fuelCards: new FuelCards(provider),
    tollRoads: new TollRoads(provider),
    savedFilters: new SavedFilters(provider),
  };
};

export default getApiTypicode;
